export enum EAppointmentStatus {
  Scheduled = 1,
  Rescheduled = 2,
  Cancelled = 3,
  Completed = 4,
}
